import React from "react";

const ButtonComponent = ({ text }) => {
  return (
    <button
      type="submit"
      className="text-white bg-[#ff5028;] hover:bg-[#ff5028cf] focus:none focus:outline-none focus:none font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center me-2 mb-2"
    >
      {text}
    </button>
  );
};

export default ButtonComponent;
